import Handlebars from 'handlebars';

// Make Handlebars available globally
window.Handlebars = window.Handlebars || Handlebars;
window.Handlebars.templates = window.Handlebars.templates || {};

// Search Results Template
const searchResultsTemplate = `
{{#if response.hits}}    
    <ol class="c-search-results {{#if layoutModifier}}c-search-results--{{layoutModifier}}{{/if}}">
        {{#each response.hits}}
            <li class="c-search-results__list-item">
                <a class="c-search-results__result is-{{type}}" href="{{link}}" aria-labelledby="search-result-title-{{@index}}">
                    <div class="c-search-results__thumb">
                        {{#compare type "collection" operator="==="}}
                            <div class="c-search-results__collection">
                                {{#each thumbnails}}
                                    <div class="c-search-results__collection-item">
                                        <img loading="lazy" alt=""
                                                src="{{this}}" />
                                        <div class="c-swiper__penguin"></div>
                                    </div>
                                {{/each}}
                            </div>
                        {{else}}
                            {{#if initials}}
                                {{> missing-author}}
                            {{else if thumbnail}}
                                <img loading="lazy" class="c-search-results__img {{#if thumbnailClass}}{{thumbnailClass}}{{/if}}" alt=""
                                    src="{{thumbnail}}"
                                />
                                <div class="c-swiper__penguin"></div>
                            {{/if}}
                        {{/compare}}
                    </div>
                    <div class="c-search-results__content">
                        <div class="c-search-results__title u-line-clamp" id="search-result-title-{{@index}}" data-maxlines="3">{{title}}</div>
                        {{#if subtitle}}
                            <div class="c-search-results__desc u-line-clamp" data-maxlines="2">{{{subtitle}}}</div>
                        {{/if}}
                    </div>
                    <div class="c-search-results__type">{{type}}</div>
                </a>
            </li>
        {{/each}}
    </ol>
    {{#if isAutocomplete}}
        <a class="c-search-results__see-all" href="{{seeAllUrl}}">See all {{response.nbHits}} results&hellip;</a>
    {{else}}
        <button class="c-search-results__load-more">Load more</button>
    {{/if}}
{{else}}
    <div class="c-search-results__none">
        <div class="c-search-results__none-content">
            <img class="c-search-results__none-penguin" width="106" src="data:image/png;base64,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" alt="" />
            <p class="c-search-results__none-title">No results found.</p>
        </div>
    </div>
{{/if}}
`;

// Filters Template
const filtersTemplate = `
<div class="c-filters c-filters--primary">
    <div class="l-gutters">
        <div class="l-container">
            {{> filters-list primary }}
            {{#if primary.filters.length}}
                <button class="c-filters__show-more" type="button">
                    <span class="c-filters__show-more-label">
                        <span>show more filters</span>
                        <span>hide more filters</span>
                    </span>
                    <span class="c-filters__show-more-arrow"></span>
                </button>
            {{/if}}
        </div>
    </div>
</div>
<!-- desktop -->
<div class="c-filters c-filters--secondary">
    <div class="l-gutters">
        <div class="l-container">
            {{#each secondary}}
                <h3 class="c-filters__heading">Filter by {{#toLower title}}{{/toLower}}</h3>
                {{> filters-list }}
            {{/each}}
        </div>
    </div>
</div>
<!-- /desktop -->
`;

// Filters Panel Template
const filtersPanelTemplate = `
<div class="c-filters-panel__header">
    <h2 class="c-filters-panel__heading">Filter by...</h2>
    <button class="c-filters-panel__clear-btn js-clear-filters" type="button">clear filters</button>
</div>
<div class="c-filters-panel__scroll">
    {{#each secondary}}
        <button class="c-filters-panel__category js-filter-trigger" type="button">
            {{title}}
            <span></span>
            <svg class="c-filters-panel__category-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 18 18">
                <line x1="9" y1="1" x2="9" y2="18" fill="none" stroke="#747578" stroke-linecap="round" stroke-width="2"/>
                <line x1="18" y1="9" x2="1" y2="9" fill="none" stroke="#747578" stroke-linecap="round" stroke-width="2"/>
            </svg>
        </button>
        {{> filters-list }}
    {{/each}}
</div>
<button class="c-filters-panel__close-btn js-close-filters" type="button">close</button>
`;

// Pre-compiled template functions (CSP-safe, no eval/Function constructor)
window.Handlebars.templates = window.Handlebars.templates || {};

// Search Results Template Function
window.Handlebars.templates["search-results"] = function(data) {
    const { response, layoutModifier, isAutocomplete, resultsExhausted, seeAllUrl } = data;
    
    if (!response.hits || response.hits.length === 0) {
        return `
            <div class="c-search-results__none">
                <div class="c-search-results__none-content">
                    <img class="c-search-results__none-penguin" width="106" src="data:image/png;base64,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" alt="" />
                    <p class="c-search-results__none-title">No results found.</p>
                </div>
            </div>
        `;
    }
    
    const layoutClass = layoutModifier ? `c-search-results--${layoutModifier}` : '';
    const resultsHtml = response.hits.map((hit, index) => {
        const thumbHtml = hit.type === 'collection' 
            ? `<div class="c-search-results__collection">
                ${hit.thumbnails ? hit.thumbnails.map(thumb => `
                    <div class="c-search-results__collection-item">
                        <img loading="lazy" alt="" src="${thumb}" />
                        <div class="c-swiper__penguin"></div>
                    </div>
                `).join('') : ''}
            </div>`
            : hit.initials 
                ? `<div class="missing-author">
                    <div class="missing-author__bg">
                        <div class="b-lazy" data-src="${hit.thumbnail}"></div>
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAQAAACWCLlpAAAA3klEQVR42u3QQREAAAwCoNm/9Cr49iACOWpRIEuWLFmyZCmQJUuWLFmyFMiSJUuWLFkKZMmSJUuWLAWyZMmSJUuWAlmyZMmSJUuBLFmyZMmSpUCWLFmyZMlSIEuWLFmyZCmQJUuWLFmyFMiSJUuWLFkKZMmSJUuWLAWyZMmSJUuWAlmyZMmSJUuBLFmyZMmSpUCWLFmyZMlSIEuWLFmyZCmQJUuWLFmyFMiSJUuWLFkKZMmSJUuWLAWyZMmSJUuWAlmyZMmSJUuBLFmyZMmSpUCWLFmyZMlSIEuWLFmbHrcjAJdeLWiCAAAAAElFTkSuQmCC" alt="">
                    </div>
                    <svg class="missing-author__svg" viewBox="0 0 100 100" width="80%" height="80%">
                        <defs>
                            <mask id="mask-${hit.maskId || 'default'}">
                                <rect class="missing-author__mask-rect" width="100%" height="100%"></rect>
                                <svg class="missing-author__mask-svg" x="50%" y="50%">
                                    <text x="0" y="15" text-anchor="middle">${hit.initials}</text>
                                </svg>
                            </mask>
                        </defs>
                        <circle class="missing-author__circle" mask="url(#mask-${hit.maskId || 'default'})" cx="50" cy="50" r="50"></circle>
                    </svg>
                </div>`
                : hit.thumbnail 
                    ? `<img class="c-search-results__img ${hit.thumbnailClass || ''}" alt="" src="${hit.thumbnail}" /><div class="c-swiper__penguin"></div>`
                    : '';
        
        const subtitleHtml = hit.subtitle ? `<div class="c-search-results__desc u-line-clamp" data-maxlines="2">${hit.subtitle}</div>` : '';
        
        return `
            <li class="c-search-results__list-item">
                <a class="c-search-results__result is-${hit.type}" href="${hit.link}" aria-labelledby="search-result-title-${index}">
                    <div class="c-search-results__thumb">${thumbHtml}</div>
                    <div class="c-search-results__content">
                        <div class="c-search-results__title u-line-clamp" id="search-result-title-${index}" data-maxlines="3">${hit.title}</div>
                        ${subtitleHtml}
                    </div>
                    <div class="c-search-results__type">${hit.type}</div>
                </a>
            </li>
        `;
    }).join('');
    
    const loadMoreHtml = isAutocomplete 
        ? `<a class="c-search-results__see-all" href="${seeAllUrl}">See all ${response.nbHits} results&hellip;</a>`
        : `<button class="c-search-results__load-more">Load more</button>`;
    
    return `
        <ol class="c-search-results ${layoutClass}">
            ${resultsHtml}
        </ol>
        ${loadMoreHtml}
    `;
};

// Filters Template Function
window.Handlebars.templates["filters"] = function(data) {
    const { primary, secondary } = data;
    
    if (!primary.filters || primary.filters.length === 0) {
        return '';
    }
    
    const primaryFiltersHtml = primary.filters.map(filter => `
        <button class="c-filter-list__btn ${filter.selected ? 'is-selected' : ''}" 
                data-facet-key="${filter.facetKey}" 
                data-facet-list="${filter.facetList}">
            <span class="c-filter-list__btn-count">${filter.total}</span>
            <span class="c-filter-list__btn-label">${filter.title}</span>
        </button>
    `).join('');
    
    const secondaryFiltersHtml = secondary.map(section => `
        <h3 class="c-filters__heading">Filter by ${section.title.toLowerCase()}</h3>
        ${section.filters.map(filter => `
            <button class="c-filter-list__btn ${filter.selected ? 'is-selected' : ''}" 
                    data-facet-key="${filter.facetKey}" 
                    data-facet-list="${filter.facetList}">
                <span class="c-filter-list__btn-count">${filter.total}</span>
                <span class="c-filter-list__btn-label">${filter.title}</span>
            </button>
        `).join('')}
    `).join('');
    
    return `
        <div class="c-filters c-filters--primary">
            <div class="l-gutters">
                <div class="l-container">
                    <div class="c-filter-list">
                        ${primaryFiltersHtml}
                    </div>
                    <button class="c-filters__show-more" type="button">
                        <span class="c-filters__show-more-label">
                            <span>show more filters</span>
                            <span>hide more filters</span>
                        </span>
                        <span class="c-filters__show-more-arrow"></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-filters c-filters--secondary">
            <div class="l-gutters">
                <div class="l-container">
                    ${secondaryFiltersHtml}
                </div>
            </div>
        </div>
    `;
};

// Filters Panel Template Function
window.Handlebars.templates["filters-panel"] = function(data) {
    const { secondary } = data;
    
    const secondaryFiltersHtml = secondary.map(section => `
        <button class="c-filters-panel__category js-filter-trigger" type="button">
            ${section.title}
            <span></span>
            <svg class="c-filters-panel__category-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 18 18">
                <line x1="9" y1="1" x2="9" y2="18" fill="none" stroke="#747578" stroke-linecap="round" stroke-width="2"/>
                <line x1="18" y1="9" x2="1" y2="9" fill="none" stroke="#747578" stroke-linecap="round" stroke-width="2"/>
            </svg>
        </button>
        <div class="c-filter-list">
            ${section.filters.map(filter => `
                <button class="c-filter-list__btn ${filter.selected ? 'is-selected' : ''}" 
                        data-facet-key="${filter.facetKey}" 
                        data-facet-list="${filter.facetList}">
                    <span class="c-filter-list__btn-count">${filter.total}</span>
                    <span class="c-filter-list__btn-label">${filter.title}</span>
                </button>
            `).join('')}
        </div>
    `).join('');
    
    return `
        <div class="c-filters-panel__header">
            <h2 class="c-filters-panel__heading">Filter by...</h2>
            <button class="c-filters-panel__clear-btn js-clear-filters" type="button">clear filters</button>
        </div>
        <div class="c-filters-panel__scroll">
            ${secondaryFiltersHtml}
        </div>
        <button class="c-filters-panel__close-btn js-close-filters" type="button">close</button>
    `;
};

export default Handlebars;
